export default __webpack_public_path__ + "static/media/Artboard 22.d6ad7809.png";